import React from 'react'
import { NextSeo } from 'next-seo'
import { IArticlePreview } from '@hypotenuse/common/src/interfaces/Blog'
import { APP_BASE_URL } from '../../Constants'

interface Props {
  articlePreview: IArticlePreview
}

const ArticlePreviewSEO: React.FC<Props> = (props) => {
  const { articlePreview } = props
  const { title } = articlePreview
  return (
    <NextSeo
      title={title}
      description="Get an entire blog post written in minutes with AI."
      openGraph={{
        title,
        url: `${APP_BASE_URL}/article/${articlePreview.id}`,
        type: 'article',
        images: [
          {
            url: `${APP_BASE_URL}/opengraph_preview.png`
          }
        ]
      }}
    />
  )
}
export default ArticlePreviewSEO
